import _ from 'lodash';

import type { TemplateImageKind } from 'src/services/reports/types';

import { ReportTemplateDesign } from '../types';

const DESIGN_IMAGE_FIELDS = {
  cover: { key: 'coverImageKey', url: 'coverImageUrl' },
  site: { key: 'siteImageKey', url: 'siteImageUrl' },
} as const;

type DesignInput = Partial<ReportTemplateDesign> | undefined;

export const getDesignImageUrl = (design: DesignInput, kind: TemplateImageKind) =>
  design?.[DESIGN_IMAGE_FIELDS[kind].url];

export const setDesignImage = <D extends DesignInput>(
  design: D,
  kind: TemplateImageKind,
  image: { key: string; url: string }
) => ({
  ...design,
  [DESIGN_IMAGE_FIELDS[kind].key]: image.key,
  [DESIGN_IMAGE_FIELDS[kind].url]: image.url,
});

// Omits the image fields rather than blanking them: PATCH replaces design whole, so a missing key is a remove.
export const removeDesignImage = <D extends DesignInput>(design: D, kind: TemplateImageKind) =>
  _.omit(design, [DESIGN_IMAGE_FIELDS[kind].key, DESIGN_IMAGE_FIELDS[kind].url]);

export const omitDesignImageUrls = <D extends DesignInput>(design: D) =>
  _.omit(design, [DESIGN_IMAGE_FIELDS.cover.url, DESIGN_IMAGE_FIELDS.site.url]);
